import { render, staticRenderFns } from "./exchangeRank.vue?vue&type=template&id=87e58ef6&scoped=true"
import script from "./exchangeRank.vue?vue&type=script&lang=js"
export * from "./exchangeRank.vue?vue&type=script&lang=js"
import style0 from "./exchangeRank.vue?vue&type=style&index=0&id=87e58ef6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e58ef6",
  null
  
)

export default component.exports